export class ParentChildInvestigationItemEntity {
  public id!: string;
  public investigationId!: string;
  public investigationNumber!: string;
  public investigationTypeName!: string;
  public statusName!: string;
  public statusColor!: string;
  public requestorName!: string;
  public linkType!: 'parent' | 'child';
}

export class ParentChildInvestigationsEntity {
  public parentInvestigation!: ParentChildInvestigationItemEntity | null;
  public childInvestigations!: ParentChildInvestigationItemEntity[];
}
